import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"height":"316px"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body p-5\"><div class=\"bg-lighten p-1\"><div class=\"row\"><div class=\"col-4\"><div class=\"w-100\"><div class=\"rounded-circle\"><img class=\"p-3 text-white img-fluid\" src=\"/media/logos/logo_sens.svg\" alt=\"\" style=\"\"></div></div></div><div class=\"col-7\"><div><div><p>SENSOR 738273</p></div><div class=\"d-flex\"><div class=\"rounded-circle\"><i class=\"bi bi-thermometer-half\"></i></div><p style=\"color:#999999;font-size:14px;\"> Temperatura externa </p><p class=\"text-warning fw-bold\">37°</p></div></div></div></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}